import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';

@Injectable()
export class UbigeoService {

  constructor(private http:HttpClient,) { }

  getUbigeoList(data){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND+'/ubigeoList?filter='+data, { headers : headers})
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/ubigeo.service.ts